module.exports = __webpack_public_path__ + "media/images/photos/c3-4bfe7639379213b6f1af7d2f7c585ef6.jpg";